import React from "react";

export const SeoPages = {
    TeleprompterOnlineGratis: React.lazy(() =>
        import("../pages/seo/TeleprompterOnlineGratis").then((module) => ({
            default: module.TeleprompterOnlineGratis,
        }))
    ),
    ComoUsarTeleprompter: React.lazy(() =>
        import("../pages/seo/ComoUsarTeleprompter").then((module) => ({ default: module.ComoUsarTeleprompter }))
    ),
    MelhorAppTeleprompter: React.lazy(() =>
        import("../pages/seo/MelhorAppTeleprompter").then((module) => ({
            default: module.MelhorAppTeleprompter,
        }))
    ),
    AlternativasTeleprompterConcorrente: React.lazy(() =>
        import("../pages/seo/AlternativasTeleprompterConcorrente").then((module) => ({
            default: module.AlternativasTeleprompterConcorrente,
        }))
    ),
    TeleprompterParaYoutubers: React.lazy(() =>
        import("../pages/seo/TeleprompterParaYoutubers").then((module) => ({
            default: module.TeleprompterParaYoutubers,
        }))
    ),
    TeleprompterTravandoSolucao: React.lazy(() =>
        import("../pages/seo/TeleprompterTravandoSolucao").then((module) => ({
            default: module.TeleprompterTravandoSolucao,
        }))
    ),
    TeleprompterCaseiroDIY: React.lazy(() =>
        import("../pages/seo/TeleprompterCaseiroDIY").then((module) => ({
            default: module.TeleprompterCaseiroDIY,
        }))
    ),
    OratoriaVideo: React.lazy(() =>
        import("../pages/seo/OratoriaVideo").then((module) => ({ default: module.OratoriaVideo }))
    ),
    ComoDecorarTexto: React.lazy(() =>
        import("../pages/seo/ComoDecorarTexto").then((module) => ({ default: module.ComoDecorarTexto }))
    ),
    WebRtcLatency: React.lazy(() =>
        import("../pages/seo/WebRtcLatencyPage").then((module) => ({ default: module.WebRtcLatencyPage }))
    ),
    TeleprompterPCWindows: React.lazy(() =>
        import("../pages/seo/TeleprompterPCWindows").then((module) => ({ default: module.TeleprompterPCWindows }))
    ),
    TeleprompterZoomMeeting: React.lazy(() =>
        import("../pages/seo/TeleprompterZoomMeeting").then((module) => ({
            default: module.TeleprompterZoomMeeting,
        }))
    ),
    TeleprompterTikTokShorts: React.lazy(() =>
        import("../pages/seo/TeleprompterTikTokShorts").then((module) => ({
            default: module.TeleprompterTikTokShorts,
        }))
    ),
    TeleprompterObsStudio: React.lazy(() =>
        import("../pages/seo/TeleprompterObsStudio").then((module) => ({
            default: module.TeleprompterObsStudio,
        }))
    ),
    TeleprompterCapCut: React.lazy(() =>
        import("../pages/seo/TeleprompterCapCut").then((module) => ({
            default: module.TeleprompterCapCut,
        }))
    ),
    TeleprompterWebVsHardware: React.lazy(() =>
        import("../pages/seo/TeleprompterWebVsHardware").then((module) => ({
            default: module.TeleprompterWebVsHardware,
        }))
    ),
    TeleprompterGoogleMeetTeams: React.lazy(() =>
        import("../pages/seo/TeleprompterGoogleMeetTeams").then((module) => ({
            default: module.TeleprompterGoogleMeetTeams,
        }))
    ),
    TeleprompterIphoneIpad: React.lazy(() =>
        import("../pages/seo/TeleprompterIphoneIpad").then((module) => ({
            default: module.TeleprompterIphoneIpad,
        }))
    ),
    TeleprompterApresentacoes: React.lazy(() =>
        import("../pages/seo/TeleprompterApresentacoes").then((module) => ({
            default: module.TeleprompterApresentacoes,
        }))
    ),
    ComoInstalarPwa: React.lazy(() =>
        import("../pages/seo/ComoInstalarPwa").then((module) => ({
            default: module.ComoInstalarPwa,
        }))
    ),
    PrivacidadeSeguranca: React.lazy(() =>
        import("../pages/seo/PrivacidadeSeguranca").then((module) => ({
            default: module.PrivacidadeSeguranca,
        }))
    ),
    TeleprompterScriptsPage: React.lazy(() =>
        import("../pages/seo/TeleprompterScriptsPage").then((module) => ({
            default: module.TeleprompterScriptsPage,
        }))
    ),
    TeleprompterScriptCategory: React.lazy(() =>
        import("../pages/seo/ScriptCategoryPage").then((module) => ({
            default: module.ScriptCategoryPage,
        }))
    ),
    TeleprompterOQueE: React.lazy(() =>
        import("../pages/seo/TeleprompterOQueE").then((module) => ({
            default: module.TeleprompterOQueE,
        }))
    ),
    TeleprompterModoMusico: React.lazy(() =>
        import("../pages/seo/TeleprompterModoMusico").then((module) => ({
            default: module.TeleprompterModoMusico,
        }))
    ),
    TeleprompterPacingTimer: React.lazy(() =>
        import("../pages/seo/TeleprompterPacingTimer").then((module) => ({
            default: module.TeleprompterPacingTimer,
        }))
    ),
    TeleprompterShortcuts: React.lazy(() =>
        import("../pages/seo/TeleprompterShortcuts").then((module) => ({
            default: module.TeleprompterShortcuts,
        }))
    ),
    TeleprompterGamers: React.lazy(() =>
        import("../pages/seo/TeleprompterGamers").then((module) => ({
            default: module.TeleprompterGamers,
        }))
    ),
    TeleprompterSlides: React.lazy(() =>
        import("../pages/seo/TeleprompterSlides").then((module) => ({
            default: module.TeleprompterSlides,
        }))
    ),
    TeleprompterTablet: React.lazy(() =>
        import("../pages/seo/TeleprompterTablet").then((module) => ({
            default: module.TeleprompterTablet,
        }))
    ),
    TeleprompterModoBilingue: React.lazy(() =>
        import("../pages/seo/TeleprompterModoBilingue").then((module) => ({
            default: module.TeleprompterModoBilingue,
        }))
    ),
    TeleprompterFitness: React.lazy(() =>
        import("../pages/seo/TeleprompterFitness").then((module) => ({
            default: module.TeleprompterFitness,
        }))
    ),
    HubGuidePage: React.lazy(() =>
        import("../pages/seo/HubGuidePage").then((module) => ({
            default: module.HubGuidePage,
        }))
    ),
    TeleprompterVsTelelestrador: React.lazy(() =>
        import("../pages/seo/TeleprompterVsTelelestrador").then((module) => ({
            default: module.TeleprompterVsTelelestrador,
        }))
    ),
    HistoriaDoTeleprompter: React.lazy(() =>
        import("../pages/seo/HistoriaDoTeleprompter").then((module) => ({
            default: module.HistoriaDoTeleprompter,
        }))
    ),
    CelebridadesUsamTeleprompter: React.lazy(() =>
        import("../pages/seo/CelebridadesUsamTeleprompter").then((module) => ({
            default: module.CelebridadesUsamTeleprompter,
        }))
    ),
    ErrosComunsTeleprompter: React.lazy(() =>
        import("../pages/seo/ErrosComunsTeleprompter").then((module) => ({
            default: module.ErrosComunsTeleprompter,
        }))
    ),
    ComoEscolherTeleprompter: React.lazy(() =>
        import("../pages/seo/ComoEscolherTeleprompter").then((module) => ({
            default: module.ComoEscolherTeleprompter,
        }))
    ),
    TeleprompterParaLives: React.lazy(() =>
        import("../pages/seo/TeleprompterParaLives").then((module) => ({
            default: module.TeleprompterParaLives,
        }))
    ),
    TeleprompterParaPodcast: React.lazy(() =>
        import("../pages/seo/TeleprompterParaPodcast").then((module) => ({
            default: module.TeleprompterParaPodcast,
        }))
    ),
    VelocidadeLeituraTeleprompter: React.lazy(() =>
        import("../pages/seo/VelocidadeLeituraTeleprompter").then((module) => ({
            default: module.VelocidadeLeituraTeleprompter,
        }))
    ),
    TeleprompterAcessibilidade: React.lazy(() =>
        import("../pages/seo/TeleprompterAcessibilidade").then((module) => ({
            default: module.TeleprompterAcessibilidade,
        }))
    ),
    FuturoTelepromptersAi: React.lazy(() =>
        import("../pages/seo/FuturoTelepromptersAi").then((module) => ({
            default: module.FuturoTelepromptersAi,
        }))
    ),
    TeleprompterEventosProfissionais: React.lazy(() =>
        import("../pages/seo/TeleprompterEventosProfissionais").then((module) => ({
            default: module.TeleprompterEventosProfissionais,
        }))
    ),
    ChecklistGravacao: React.lazy(() =>
        import("../pages/seo/ChecklistGravacao").then((module) => ({
            default: module.ChecklistGravacao,
        }))
    ),
};

export const seoKeyMap: Record<SeoRouteKey, keyof typeof SeoPages> = {
    SEO_GRATIS: "TeleprompterOnlineGratis",
    SEO_TUTORIAL: "ComoUsarTeleprompter",
    SEO_MELHOR_APP: "MelhorAppTeleprompter",
    SEO_ALTERNATIVAS: "AlternativasTeleprompterConcorrente",
    SEO_YOUTUBERS: "TeleprompterParaYoutubers",
    SEO_TRAVANDO: "TeleprompterTravandoSolucao",
    SEO_DIY: "TeleprompterCaseiroDIY",
    SEO_ORATORIA: "OratoriaVideo",
    SEO_DECORAR: "ComoDecorarTexto",
    SEO_WEBRTC: "WebRtcLatency",
    SEO_PC_WINDOWS: "TeleprompterPCWindows",
    SEO_ZOOM: "TeleprompterZoomMeeting",
    SEO_TIKTOK: "TeleprompterTikTokShorts",
    SEO_OBS: "TeleprompterObsStudio",
    SEO_CAPCUT: "TeleprompterCapCut",
    SEO_HARDWARE_VS_WEB: "TeleprompterWebVsHardware",
    SEO_MEET_TEAMS: "TeleprompterGoogleMeetTeams",
    SEO_IPHONE_IPAD: "TeleprompterIphoneIpad",
    SEO_APRESENTACOES: "TeleprompterApresentacoes",
    SEO_PWA_INSTALL: "ComoInstalarPwa",
    SEO_PRIVACY: "PrivacidadeSeguranca",
    SEO_SCRIPTS: "TeleprompterScriptsPage",
    SEO_SCRIPTS_YOUTUBE: "TeleprompterScriptCategory",
    SEO_SCRIPTS_TIKTOK: "TeleprompterScriptCategory",
    SEO_SCRIPTS_SALES: "TeleprompterScriptCategory",
    SEO_SCRIPTS_CLASSES: "TeleprompterScriptCategory",
    SEO_SCRIPTS_INSTITUTIONAL: "TeleprompterScriptCategory",
    SEO_O_QUE_E: "TeleprompterOQueE",
    SEO_MODO_MUSICO: "TeleprompterModoMusico",
    SEO_PACING: "TeleprompterPacingTimer",
    SEO_SHORTCUTS: "TeleprompterShortcuts",
    SEO_GAMER: "TeleprompterGamers",
    SEO_SLIDES_SYNC: "TeleprompterSlides",
    SEO_TABLET: "TeleprompterTablet",
    SEO_MODO_BILINGUE: "TeleprompterModoBilingue",
    SEO_FITNESS: "TeleprompterFitness",
    SEO_HUB_GUIDE: "HubGuidePage",
    SEO_VS_TELELESTRADOR: "TeleprompterVsTelelestrador",
    SEO_HISTORY: "HistoriaDoTeleprompter",
    SEO_CELEBRITIES: "CelebridadesUsamTeleprompter",
    SEO_COMMON_MISTAKES: "ErrosComunsTeleprompter",
    SEO_BUYING_GUIDE: "ComoEscolherTeleprompter",
    SEO_LIVES: "TeleprompterParaLives",
    SEO_PODCAST: "TeleprompterParaPodcast",
    SEO_READING_SPEED: "VelocidadeLeituraTeleprompter",
    SEO_ACCESSIBILITY: "TeleprompterAcessibilidade",
    SEO_FUTURE_AI: "FuturoTelepromptersAi",
    SEO_EVENTOS: "TeleprompterEventosProfissionais",
    SEO_CHECKLIST: "ChecklistGravacao",
};

export type SeoRouteKey =
    | "SEO_GRATIS"
    | "SEO_TUTORIAL"
    | "SEO_MELHOR_APP"
    | "SEO_ALTERNATIVAS"
    | "SEO_YOUTUBERS"
    | "SEO_TRAVANDO"
    | "SEO_DIY"
    | "SEO_ORATORIA"
    | "SEO_DECORAR"
    | "SEO_WEBRTC"
    | "SEO_PC_WINDOWS"
    | "SEO_ZOOM"
    | "SEO_TIKTOK"
    | "SEO_OBS"
    | "SEO_CAPCUT"
    | "SEO_HARDWARE_VS_WEB"
    | "SEO_MEET_TEAMS"
    | "SEO_IPHONE_IPAD"
    | "SEO_APRESENTACOES"
    | "SEO_PWA_INSTALL"
    | "SEO_PRIVACY"
    | "SEO_SCRIPTS"
    | "SEO_SCRIPTS_YOUTUBE"
    | "SEO_SCRIPTS_TIKTOK"
    | "SEO_SCRIPTS_SALES"
    | "SEO_SCRIPTS_CLASSES"
    | "SEO_SCRIPTS_INSTITUTIONAL"
    | "SEO_O_QUE_E"
    | "SEO_MODO_MUSICO"
    | "SEO_PACING"
    | "SEO_SHORTCUTS"
    | "SEO_GAMER"
    | "SEO_SLIDES_SYNC"
    | "SEO_TABLET"
    | "SEO_MODO_BILINGUE"
    | "SEO_FITNESS"
    | "SEO_HUB_GUIDE"
    | "SEO_VS_TELELESTRADOR"
    | "SEO_HISTORY"
    | "SEO_CELEBRITIES"
    | "SEO_COMMON_MISTAKES"
    | "SEO_BUYING_GUIDE"
    | "SEO_LIVES"
    | "SEO_PODCAST"
    | "SEO_READING_SPEED"
    | "SEO_ACCESSIBILITY"
    | "SEO_FUTURE_AI"
    | "SEO_EVENTOS"
    | "SEO_CHECKLIST";
